export default "__VITE_ASSET__FWZRg8jV__"